var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFunnyDisguise(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c7e9ff"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 86.716,
    x2: 161.043,
    xlinkHref: "#lg1",
    y1: 122.171,
    y2: 196.497
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 346.981,
    x2: 421.308,
    xlinkHref: "#lg1",
    y1: 122.171,
    y2: 196.497
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#537983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e5959"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 182.652,
    x2: 312.151,
    xlinkHref: "#lg2",
    y1: 401.404,
    y2: 401.404
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3e5959",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 240.044,
    x2: 267.377,
    xlinkHref: "#lg3",
    y1: 401.879,
    y2: 524.545
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 248.495,
    x2: 257.162,
    xlinkHref: "#lg3",
    y1: 418.564,
    y2: 492.564
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 272.592,
    x2: 272.592,
    xlinkHref: "#lg3",
    y1: 489.595,
    y2: 332.757
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 182.667,
    x2: 312.139,
    y1: 239.429,
    y2: 239.429
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdcbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0028,
    stopColor: "#ffdcbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa9b1"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc2b5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f89580"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 307.755,
    x2: 225.088,
    xlinkHref: "#lg4",
    y1: 309.925,
    y2: 206.591
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg4",
    y1: 314.262,
    y2: 361.086
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 42.546,
    x2: 221.431,
    xlinkHref: "#lg2",
    y1: 78,
    y2: 256.886
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 207.546,
    x2: 30.069,
    xlinkHref: "#lg2",
    y1: 243,
    y2: 65.524
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 124.868,
    x2: 124.868,
    xlinkHref: "#lg3",
    y1: 230.263,
    y2: 278.786
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 302.81,
    x2: 481.696,
    xlinkHref: "#lg2",
    y1: 78,
    y2: 256.886
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 467.81,
    x2: 290.334,
    xlinkHref: "#lg2",
    y1: 243,
    y2: 65.524
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 385.132,
    x2: 385.132,
    xlinkHref: "#lg3",
    y1: 230.263,
    y2: 278.786
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg2",
    y1: 99.762,
    y2: 126.762
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 124.867,
    cy: 160.322,
    fill: "url(#SVGID_1_)",
    r: 96.322
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.132,
    cy: 160.322,
    fill: "url(#SVGID_2_)",
    r: 96.322
  }), /*#__PURE__*/React.createElement("path", {
    d: "m358.06 428.718-46.957-100.456h-112.162l-47.104 100.771c-4.836 10.345-2.679 22.611 5.396 30.686 4.924 4.924 11.286 8.178 18.173 9.2.521.077 1.042.154 1.564.229 2.295.332 4.528-.917 5.445-3.047 1.999-4.64 8.795-3.897 9.743 1.065l.076.395c.422 2.208 2.232 3.895 4.467 4.142 12.928 1.426 25.896 2.367 38.877 2.841 1.142.042 2.216-.549 2.797-1.532l4.406-7.456c1.093-1.85 3.688-2.059 5.063-.409 1.17 1.404 3.293 1.5 4.585.208l5.767-5.767c1.263-1.263 3.328-1.204 4.517.128l12.213 13.687c.622.697 1.525 1.081 2.458 1.041 9.897-.418 19.784-1.124 29.652-2.096 1.124-.111 2.183-.585 3.017-1.347l4.184-3.824c2.289-2.092 5.887-1.737 7.723.762 1.129 1.536 3.006 2.34 4.895 2.085 3.279-.442 6.555-.908 9.826-1.417 7.585-1.179 14.388-5.328 18.829-11.589 5.879-8.287 6.853-19.094 2.55-28.3z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m268.232 328.262h-26.464l-65.788 140.74c.33.048.66.097.99.145 2.295.332 4.528-.917 5.445-3.047 1.999-4.64 8.795-3.897 9.743 1.065l.075.395c.422 2.208 2.232 3.895 4.467 4.142 12.928 1.426 25.896 2.367 38.877 2.841 1.142.042 2.216-.549 2.797-1.532l4.406-7.456c1.093-1.849 3.688-2.059 5.063-.409 1.17 1.404 3.293 1.5 4.585.208l5.767-5.767c1.263-1.263 3.328-1.204 4.517.128l12.213 13.687c.622.697 1.525 1.081 2.458 1.041 9.897-.418 19.784-1.124 29.652-2.096 1.124-.111 2.183-.585 3.017-1.347l4.184-3.823c2.289-2.092 5.887-1.737 7.723.762 1.129 1.536 3.006 2.34 4.895 2.085 2.391-.322 4.78-.665 7.167-1.02z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m259.715 328.262h-9.431l-24.294 145.845c3.195.174 6.391.32 9.588.437 1.142.042 2.216-.549 2.797-1.532l4.406-7.456c1.093-1.849 3.688-2.059 5.063-.409 1.17 1.404 3.293 1.5 4.585.208l5.767-5.767c1.263-1.263 3.328-1.204 4.517.128l12.213 13.687c.622.697 1.525 1.081 2.458 1.041 2.21-.093 4.42-.206 6.629-.328z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m358.06 428.718-46.957-100.456h-112.162l-14.475 30.966 113.898 113.898c2.892-.238 5.782-.493 8.67-.777 1.124-.111 2.183-.585 3.017-1.347l4.184-3.823c2.289-2.092 5.887-1.737 7.723.762 1.129 1.536 3.006 2.34 4.895 2.085 3.279-.442 6.555-.908 9.826-1.417 7.585-1.179 14.388-5.328 18.829-11.589 5.881-8.289 6.855-19.096 2.552-28.302z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m243.255 122.414-91.293 195.303c-4.303 9.206-3.329 20.014 2.551 28.302 4.441 6.26 11.245 10.409 18.829 11.589 54.113 8.415 109.203 8.415 163.317 0 7.585-1.179 14.388-5.328 18.829-11.589 5.88-8.288 6.854-19.096 2.551-28.302l-91.293-195.303c-4.66-9.966-18.832-9.966-23.491 0z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360.7 329.682c0 5.76-1.76 11.48-5.21 16.34-4.44 6.26-11.25 10.41-18.83 11.59-25.75 4.01-51.71 6.1-77.68 6.29l-87.64-87.63 71.91-153.86c4.66-9.96 18.84-9.96 23.5 0l91.29 195.31c1.78 3.81 2.66 7.89 2.66 11.96z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m151.962 317.718c-4.303 9.206-3.329 20.014 2.551 28.302 4.441 6.26 11.245 10.409 18.829 11.589 54.113 8.415 109.203 8.415 163.317 0 7.585-1.179 14.388-5.328 18.829-11.589 5.88-8.288 6.854-19.096 2.55-28.302l-11.276-24.123h-183.524z",
    fill: "url(#SVGID_9_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m124.867 285.19c-68.851 0-124.867-56.016-124.867-124.868s56.016-124.868 124.867-124.868c68.853 0 124.868 56.016 124.868 124.868s-56.015 124.868-124.868 124.868zm0-214.736c-49.553 0-89.867 40.315-89.867 89.868s40.314 89.868 89.867 89.868c49.554 0 89.868-40.314 89.868-89.868s-40.314-89.868-89.868-89.868z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124.867 51.096c-60.227 0-109.226 48.999-109.226 109.226s48.999 109.226 109.226 109.226c60.228 0 109.227-48.999 109.227-109.226s-48.999-109.226-109.227-109.226zm0 199.094c-49.553 0-89.867-40.315-89.867-89.868s40.314-89.868 89.867-89.868c49.554 0 89.868 40.314 89.868 89.868s-40.314 89.868-89.868 89.868z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m196.062 215.096c-16.447 21.327-42.241 35.094-71.195 35.094-28.953 0-54.747-13.767-71.194-35.094h-41c20.329 41.471 62.979 70.094 112.193 70.094 49.215 0 91.866-28.623 112.194-70.094z",
    fill: "url(#SVGID_12_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m385.132 285.19c-68.852 0-124.867-56.016-124.867-124.868s56.015-124.868 124.867-124.868 124.868 56.016 124.868 124.868-56.016 124.868-124.868 124.868zm0-214.736c-49.553 0-89.867 40.314-89.867 89.868s40.314 89.868 89.867 89.868c49.554 0 89.868-40.314 89.868-89.868s-40.314-89.868-89.868-89.868z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m385.132 51.096c-60.227 0-109.226 48.999-109.226 109.226s48.999 109.226 109.226 109.226c60.228 0 109.227-48.999 109.227-109.226s-48.999-109.226-109.227-109.226zm0 199.094c-49.553 0-89.867-40.314-89.867-89.868s40.314-89.868 89.867-89.868c49.554 0 89.868 40.314 89.868 89.868s-40.314 89.868-89.868 89.868z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m456.326 215.096c-16.447 21.327-42.241 35.094-71.195 35.094-28.953 0-54.747-13.767-71.194-35.094h-41c20.329 41.471 62.979 70.094 112.193 70.094 49.215 0 91.866-28.623 112.194-70.094z",
    fill: "url(#SVGID_15_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m255 92.452c-13.92 0-27.31 2.29-39.82 6.51 6.6 9.67 11.68 20.46 14.9 32.01 7.92-2.29 16.28-3.52 24.92-3.52s17 1.23 24.92 3.52c3.22-11.55 8.3-22.34 14.9-32.01-12.51-4.22-25.9-6.51-39.82-6.51z",
    fill: "url(#SVGID_16_)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFunnyDisguise);
export default __webpack_public_path__ + "static/media/icon-funny-disguise.f8a59a12b78e1510e9348229c5e65a2c.svg";
export { ForwardRef as ReactComponent };